var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorLeetcodeIcon = function SvgColorLeetcodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F1F1F4",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA9C00",
    d: "M15.445 16.795a1.07 1.07 0 0 1 1.514.003c.418.42.417 1.099-.002 1.517l-1.86 1.857a4.484 4.484 0 0 1-6.26.058l-3.35-3.285c-1.705-1.672-1.875-4.347-.27-6.066l2.992-3.203c1.592-1.706 4.528-1.892 6.35-.42l2.717 2.198c.46.372.532 1.048.16 1.509a1.07 1.07 0 0 1-1.506.16l-2.717-2.197c-.953-.77-2.618-.664-3.44.216L6.78 12.345c-.781.837-.696 2.184.205 3.067l3.334 3.27c.907.873 2.374.86 3.265-.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4CADA",
    fillRule: "evenodd",
    d: "M10.926 14.937a1.072 1.072 0 0 1 0-2.146h7.898a1.072 1.072 0 0 1 0 2.146z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#090E1C",
    fillRule: "evenodd",
    d: "M12.405 3.182a1.07 1.07 0 0 1 1.514-.05c.432.404.454 1.083.05 1.515l-7.188 7.698c-.781.836-.696 2.183.205 3.066l3.32 3.255c.422.415.43 1.094.015 1.517a1.07 1.07 0 0 1-1.514.017l-3.32-3.256c-1.705-1.672-1.875-4.347-.27-6.065z",
    clipRule: "evenodd"
  })));
};
export default SvgColorLeetcodeIcon;